import { ChevronDown } from "lucide-react";
import { WHATSAPP_LINK } from "../data/site";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const Hero = ({ onOpenConsult }) => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden grain"
    >
      {/* Background image (Dubai skyline) */}
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=2000&q=80')",
        }}
      />
      <div className="absolute inset-0 hero-overlay" />

      {/* Side accents */}
      <div className="absolute top-1/2 left-6 -translate-y-1/2 hidden lg:flex flex-col gap-2 text-[10px] tracking-[0.4em] text-white/40 rotate-180" style={{ writingMode: "vertical-rl" }}>
        <span>DUBAI · UAE</span>
      </div>
      <div className="absolute top-1/2 right-6 -translate-y-1/2 hidden lg:flex flex-col gap-2 text-[10px] tracking-[0.4em] text-[#c5a059]/70" style={{ writingMode: "vertical-rl" }}>
        <span>EST. 2024 · LICENSE #1410017</span>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center pt-24">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full glass mb-8 text-[10px] tracking-[0.35em] text-[#c5a059] uppercase" data-testid="hero-badge">
          <span className="w-1.5 h-1.5 bg-[#c5a059] rounded-full animate-pulse" />
          Authorised Channel Partner · Top UAE Developers
        </div>

        <h1
          className="font-serif-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-light leading-[1.05] mb-8"
          data-testid="hero-headline"
        >
          Luxury Living &amp;
          <br />
          <span className="gold-gradient italic font-semibold">Smart Investment</span>
        </h1>

        <p className="text-base md:text-lg text-white/70 max-w-2xl mx-auto mb-12 leading-relaxed">
          Exclusive access to Dubai&apos;s most prestigious properties — handpicked off-plan and
          ready-to-move portfolios from the city&apos;s most trusted developers.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#projects"
            className="btn-premium px-10 py-4 rounded-sm text-sm font-bold tracking-[0.25em]"
            data-testid="hero-explore-btn"
          >
            EXPLORE PROJECTS
          </a>
          <button
            type="button"
            onClick={() => onOpenConsult?.()}
            className="pulse-cta-gold btn-premium px-10 py-4 rounded-sm text-sm font-bold tracking-[0.25em] inline-flex items-center justify-center gap-2"
            data-testid="hero-consult-btn"
          >
            BOOK CONSULTATION
          </button>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            className="pulse-cta-wa inline-flex items-center justify-center gap-2 px-8 py-4 rounded-sm text-sm font-bold tracking-[0.25em] bg-[#25D366] text-white hover:opacity-90 transition"
            data-testid="hero-whatsapp-btn"
          >
            <WhatsAppIcon size={16} /> CHAT ON WHATSAPP
          </a>
        </div>

        {/* Stat row */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 max-w-4xl mx-auto rounded-xl overflow-hidden" data-testid="hero-stats">
          {[
            { v: "500+", l: "Curated Units" },
            { v: "25+", l: "Trusted Developers" },
            { v: "AED 1B+", l: "Transacted" },
            { v: "8%+", l: "Average ROI" },
          ].map((s) => (
            <div key={s.l} className="bg-[#0a1128]/80 px-6 py-6">
              <div className="font-serif-display text-2xl md:text-3xl text-[#c5a059]">{s.v}</div>
              <div className="text-[10px] tracking-[0.3em] text-white/55 uppercase mt-1">{s.l}</div>
            </div>
          ))}
        </div>
      </div>

      <a
        href="#why-dubai"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/60 hover:text-[#c5a059] flex flex-col items-center gap-2 animate-bounce"
        data-testid="hero-scroll-indicator"
      >
        <span className="text-[10px] tracking-[0.4em]">SCROLL</span>
        <ChevronDown size={18} />
      </a>
    </section>
  );
};
